import { Card, Col, Modal, Row } from 'antd';
import React from 'react';
import { createUseStyles } from 'react-jss';
import { useDispatch } from 'react-redux';
import { deleteInArray, errorCatch, GET, JSXMap, Model, POST, QueryDetail, QueryOrder, QueryParam, updateInArray } from 'fennec-ui';
import { CollectionServer } from 'fennec-ui';
import PopolnenieScheta from '../../forms/PopolnenieScheta';
import VivodSoScheta from '../../forms/VivodSoScheta';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import User from '../../../common/User';
import OstatkiPoSchetu from '../../forms/OstatkiPoSchetu';
import FederationadministratorEventsOrdersAll from '../FederationadministratorEventsOrdersAll';
import PageLayout from '../../components/PageLayout';
import FilterFieldLabel from '../../components/FilterFieldLabel';
import dayjs from 'dayjs'
import 'dayjs/locale/ru'
import confirmKey from '../../components/ConfirmKeyModal';
import Icofont from 'react-icofont';
import MDEditor, { commands, EditorContext } from "@uiw/react-md-editor";
var isBetween = require('dayjs/plugin/isBetween')
var utc = require('dayjs/plugin/utc')
var timezone = require('dayjs/plugin/timezone') // dependent on utc plugin
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.locale('ru');


var _ = require('lodash');

const useStyles = createUseStyles({
    item: {
        padding: "5px 10px",
        display: "flex",
        cursor: "pointer",
        '&:hover': {
            backgroundColor: "#f9f9f9"
        }
    },
})

export default function FederationadministratorManagementNews(props) {
    const classes = useStyles();
    const { auth } = props;
    const dispatch = useDispatch();

    const filters = () => [
        {
            label: "Номер",
            name: "ID",
            sort: true,
            filter: true,
        },
        // {
        //     label: "Тип счета",
        //     name: "akkauntType",
        //     filterType: "group",
        //     queryFilter: [
        //         QueryDetail("model"),
        //         QueryOrder("code", "ASC"),
        //         // QueryParam("w-in-id", "2,9")
        //         QueryParam("w-neq-id", "7")
        //     ],
        //     display: (o) => o.opisanie,
        //     sort: true,
        //     filter: true,
        //     // filtered: [2],
        // },
        // {
        //     label: "Баланс счета",
        //     name: "ostatok",
        //     filterType: "range",
        //     func: ["min", "max"],
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: "Номер счета",
        //     name: "nomerAkkaunta",
        //     sort: true,
        //     filter: true,
        // },
        // {
        //     label: <FilterFieldLabel label="Владелец" badge="co" color="#919191" background="rgba(216, 216, 216, 0.2)" />,
        //     name: "accountInfo.vladelets",
        //     // queryComparer:"swsim", // sim, wsim, swsim
        //     sort: true,
        //     filter: true,
        // },
    ];

    const render = (item, idx, { setCollection, setCollectionItem, removeCollectionItem, update }) => {
        return (<div key={item.ID || idx} style={{ width: "100%" }}>
            <div className={classes.item}>
                <div style={{ flex: "0 0 25px" }}>
                    {item?.opublikovana && <i className="fa fa-circle" style={{ fontSize: "8px", color: "green" }}></i>}
                    {!item?.opublikovana && <i className="fa fa-circle" style={{ fontSize: "8px", color: "red" }}></i>}
                </div>
                <div style={{ flex: "1 1 auto", overflow: "hidden" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "2px" }}>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>
                            {dayjs(item?.dataNovosti).format("DD.MM.YYYY HH:mm")}
                        </div>
                        <div style={{ fontSize: "12px", fontStyle: "italic", color: "rgba(0, 0, 0, 0.45)" }}>{item?.kategoriya?.nazvanie}</div>
                    </div>

                    <div style={{ fontSize: "14px", fontWeight: "bold", paddingBottom: "3px" }}>{item?.zagolovok} </div>
                    <div style={{ fontSize: "12px", color: "rgba(0, 0, 0, 0.85)" }}>{item?.novostSokrashchennaya} </div>
                    <div style={{ fontSize: "12px", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: "hidden" }}>
                        <a href={item?.ssilkaNaResurs} target='_blank'>{item?.ssilkaNaResurs}</a>
                    </div>
                </div>
                {/* <div style={{ flex: "0 0 150px" }}>
                    
                </div> */}
            </div>
        </div>)
    }

    // "/api/kategoriya-novostei/create"
    // "/api/kategoriya-novostei/update"
    // "/api/kategoriya-novostei/delete/{id}"
    // "/api/novosti/create"
    // "/api/novosti/update"
    // "/api/novosti/delete/{id}"

    // KategoriyaNovostei
    // Novosti

    // Списки стандарными сервисами

    return (
        <PageLayout>
            <div style={{ padding: "5px 10px", backgroundColor: "white", borderRadius: "4px" }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ paddingBottom: "15px", fontSize: "18px" }}>Новости</div>
                </div>
                <CollectionServer
                    auth={auth}
                    name={"Novosti"}
                    // queryDetail={"collection"}
                    // source={"/api/fed/admin/akkaunti-polzovatelei"}
                    filters={filters}
                    size={"small"}
                    mode={"list"}
                    // title="Новости"
                    render={render}

                    collectionActions={() => [
                        {
                            auth: auth,
                            action: (values, unlock, close, { collection, setCollection }) => {
                                POST(auth, `/api/novosti/create`, { ...values },
                                    ({ data }) => {
                                        setCollection(updateInArray(collection, data, true));
                                        close();
                                    }, (err) => errorCatch(err, unlock)
                                );
                            },
                            title: "Создать новость",
                            modal: {
                                title: "Создание новости",
                                width: "650px"
                            },
                            form: Model,
                            meta: [
                                {
                                    label: "Категория",
                                    name: "kategoriya",
                                    type: "object",
                                    relation: {
                                        display: (item) => {
                                            return item.nazvanie
                                        },
                                        reference: { object: "KategoriyaNovostei", property: "ID" },
                                        type: "many-one",
                                    },
                                    queryFilter: [
                                        QueryDetail("model"),
                                        QueryOrder("nazvanie", "ASC")
                                    ],

                                    dropdownActions: () => [
                                        {
                                            title: "Создать категорию",
                                            form: Model,
                                            meta: [
                                                {
                                                    label: "Название",
                                                    name: "nazvanie",
                                                    type: "string",
                                                },
                                                {
                                                    label: "Описание",
                                                    name: "opisanie",
                                                    type: "string",
                                                },
                                            ],
                                            action: (values, unlock, close, { collection, setCollection, apply }) => {
                                                POST(auth, '/api/kategoriya-novostei/create', { ...values },
                                                    ({ data }) => {
                                                        setCollection(updateInArray(collection, data));
                                                        if (apply) {
                                                            apply(data);
                                                        }
                                                        close();
                                                    },
                                                    (err) => errorCatch(err, unlock)
                                                );
                                            },
                                        },
                                    ]
                                },
                                {
                                    label: "Опубликована",
                                    name: "opublikovana",
                                    type: "bool",
                                },
                                {
                                    label: "Дата новости",
                                    name: "dataNovosti",
                                    type: "date",
                                },
                                {
                                    label: "Заголовок",
                                    name: "zagolovok",
                                    type: "string",
                                },
                                {
                                    label: "Новость сокращенная",
                                    name: "novostSokrashchennaya",
                                    type: "func",
                                    render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                        return (<MDEditor
                                            data-color-mode="light"
                                            value={value} onChange={onChange}
                                            preview={"edit"}
                                            overflow={false}
                                        />)
                                    }
                                },
                                {
                                    label: "Полный текст новости",
                                    name: "novost",
                                    type: "func",
                                    render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                        return (<MDEditor
                                            data-color-mode="light"
                                            value={value} onChange={onChange}
                                            preview={"edit"}
                                            overflow={false}
                                        />)
                                    }
                                },
                                {
                                    label: "Ссылка на ресурс",
                                    name: "ssilkaNaResurs",
                                    type: "string",
                                },
                            ],
                        }]}
                    modelActions={(item) => {
                        return [
                            {
                                auth: auth,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    POST(auth, `/api/novosti/update`, { ...values, ID: item?.ID },
                                        ({ data }) => {
                                            setCollection(updateInArray(collection, data, true));
                                            close();
                                        }, (err) => errorCatch(err, unlock)
                                    );
                                },
                                title: "Изменить",
                                modal: {
                                    title: "Изменение новости",
                                    width: "650px"
                                },
                                form: Model,
                                meta: [
                                    {
                                        label: "Категория",
                                        name: "kategoriya",
                                        type: "object",
                                        relation: {
                                            display: (item) => {
                                                return item.nazvanie
                                            },
                                            reference: { object: "KategoriyaNovostei", property: "ID" },
                                            type: "many-one",
                                        },
                                        queryFilter: [
                                            QueryDetail("model"),
                                            QueryOrder("nazvanie", "ASC")
                                        ],

                                        dropdownActions: () => [
                                            {
                                                title: "Создать категорию",
                                                form: Model,
                                                meta: [
                                                    {
                                                        label: "Название",
                                                        name: "nazvanie",
                                                        type: "string",
                                                    },
                                                    {
                                                        label: "Описание",
                                                        name: "opisanie",
                                                        type: "string",
                                                    },
                                                ],
                                                action: (values, unlock, close, { collection, setCollection, apply }) => {
                                                    POST(auth, '/api/kategoriya-novostei/create', { ...values },
                                                        ({ data }) => {
                                                            setCollection(updateInArray(collection, data));
                                                            if (apply) {
                                                                apply(data);
                                                            }
                                                            close();
                                                        },
                                                        (err) => errorCatch(err, unlock)
                                                    );
                                                },
                                            },
                                        ]
                                    },
                                    {
                                        label: "Опубликована",
                                        name: "opublikovana",
                                        type: "bool",
                                    },
                                    {
                                        label: "Дата новости",
                                        name: "dataNovosti",
                                        type: "date",
                                    },
                                    {
                                        label: "Заголовок",
                                        name: "zagolovok",
                                        type: "string",
                                    },
                                    {
                                        label: "Новость сокращенная",
                                        name: "novostSokrashchennaya",
                                        type: "func",
                                        render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                            return (<MDEditor
                                                data-color-mode="light"
                                                value={value} onChange={onChange}
                                                preview={"edit"}
                                                overflow={false}
                                            />)
                                        }
                                    },
                                    {
                                        label: "Полный текст новости",
                                        name: "novost",
                                        type: "func",
                                        render: (auth, item, value, onChange, onAfterChange, isChanged) => {
                                            return (<MDEditor
                                                data-color-mode="light"
                                                value={value} onChange={onChange}
                                                preview={"edit"}
                                                overflow={false}
                                            />)
                                        }
                                    },
                                    {
                                        label: "Ссылка на ресурс",
                                        name: "ssilkaNaResurs",
                                        type: "string",
                                    },
                                ],
                            },
                            {
                                auth: auth,
                                title: <span style={{ color: "red" }}>Удалить</span>,
                                action: (values, unlock, close, { collection, setCollection }) => {
                                    confirmKey({
                                        pass: '123',
                                        title: <span><Icofont icon="check-circled" style={{ color: "orange" }} /> Удалить новость</span>,
                                        icon: undefined,
                                        content: <div>
                                            <div>Вы действительно хотите удалить новость?</div>
                                            <div style={{ fontSize: "14px", fontWeight: "bold" }}>{item?.zagolovok} </div>
                                        </div>,
                                        okText: 'Удалить',
                                        cancelText: 'Отмена',
                                        onOk() {
                                            return new Promise((resolve, reject) => {
                                                GET(auth, '/api/novosti/delete/' + item.ID,
                                                    ({ data }) => {
                                                        setCollection(deleteInArray(collection, item));
                                                        resolve(data);
                                                    }, (err) => errorCatch(err, reject));
                                            }).catch(() => { });
                                        },
                                        onCancel() {
                                        },
                                    })
                                }
                            }
                        ]
                    }}
                />
            </div>
        </PageLayout>

    );
}
